import createModalContainer from './utils';

interface FunctionalModalProps {
  title?: string;
  message?: string;
  onOk?: (...args: any[]) => any;
  onCancel?: (...args: any[]) => any;
  okText?: string;
  cancelText?: string;
}

/**
 * Confirm Modal Component in Vanilla JS
 * Functions similarly to Ant Design's Modal.confirm just without JSX
 */
const ConfirmModal = ({ title, message, onOk, onCancel, okText, cancelText }: FunctionalModalProps) => {
  // CSS is in vl-md/src/assets/MdModal.css
  // Container
  const { closeDialog, dialog, closeButton, footer } = createModalContainer(title, message);

  const handleAction = async (action?: (...args: any[]) => any) => {
    if (!action) {
      closeDialog();
      return;
    }

    try {
      if (action.length > 0) {
        await action();
      } else {
        const result = action();
        if (result === false) return;
        if (result instanceof Promise) {
          const resolvedResult = await result;
          if (resolvedResult === false) return;
        }
        closeDialog();
      }
    } catch (error) {
      console.error('Error in action:', error); // Handle errors in the action
    }
  };

  const handleOk = () => handleAction(onOk);
  const handleCancel = () => handleAction(onCancel);

  dialog.addEventListener('cancel', (event) => {
    event.preventDefault();
    handleCancel().then();
  });

  dialog.addEventListener('click', (event) => {
    const rect = dialog.getBoundingClientRect();
    const isInDialog =
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom;

    if (!isInDialog) {
      handleCancel().then(); // Execute handleCancel if the click is outside the modal
    }
  });

  if (closeButton) {
    closeButton.onclick = handleCancel;
  }

  // Cancel button
  const cancelButton = document.createElement('button');
  cancelButton.textContent = cancelText ?? 'Cancel';
  cancelButton.className = 'md-cancel ant-btn ant-btn-default';
  cancelButton.onclick = handleCancel;
  footer.appendChild(cancelButton);
  // OK button
  const okButton = document.createElement('button');
  okButton.textContent = okText ?? 'OK';
  okButton.className = 'md-ok ant-btn ant-btn-primary';
  okButton.onclick = handleOk;
  footer.appendChild(okButton);

  dialog.showModal();
};

export default ConfirmModal;
